const AppTag = (api: any) => ({
  getAppTags: () => api.get("/appTag/getAppTags.php", {}, {}),
  createAppTag: (data: any) =>
      api.post("/appTag/createAppTag.php", {}, data),
  searchAppTagRelationship: (data: any) =>
      api.post("/appTag/searchAppTagRelationship.php", {}, data),
    deleteAppTagRelationship: (data: any) =>
      api.remove("/appTag/deleteAppTagRelationship.php", {}, data),
    createAppTagRelationship: (data: any) =>
      api.post("/appTag/createAppTagRelationship.php", {}, data),
  });
  
  export default AppTag;